import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Testimonial2 from "./Testimonial2";
import { useTranslation } from "react-i18next";



import testimonial1 from "../../Assets/syepMain.png";
import testimonial2 from "../../Assets/gradSYEP.png";
import testimonial3 from "../../Assets/syep_2025.jpeg";
import testimonial4 from "../../Assets/Choicest_Fruit.png";




// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";




const sliderImages = [
  { src: testimonial1, altKey: "testimonialsPage.sliderAlts.0" },
  { src: testimonial2, altKey: "testimonialsPage.sliderAlts.1" },
  { src: testimonial3, altKey: "testimonialsPage.sliderAlts.2" },
  { src: testimonial4, altKey: "testimonialsPage.sliderAlts.3" },
];


function Testimonial() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);
 



  // Settings for the Slick slider
  const settings = {
    dots: false, // Dots are globally hidden in CSS
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3500, // Time between slides in ms
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: true,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };



  return (
    <Container fluid className="about-section testimonials-page">
      <Particle />
      <Container className="testimonials-container">
        <header className="testimonials-hero">
          <h1 className="testimonials-hero-title">
            {t("testimonialsPage.hero.title")}
          </h1>
          <p className="testimonials-hero-lead">
            {t("testimonialsPage.hero.lead")}
          </p>
        </header>

        <Row className="testimonials-top" style={{ justifyContent: "center" }}>
          <Col md={12}>
            <div className="policy-card testimonials-slider-card" aria-label={t("testimonialsPage.a11y.highlights")}> 
              <Slider {...settings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="testimonials-slide">
                    <SlickLazyImage
                      src={image.src}
                      alt={t(image.altKey)}
                      className="testimonials-slide-img"
                      index={index}
                      activeIndex={activeSlide}
                      total={sliderImages.length}
                      buffer={2}
                      eager
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        <Testimonial2 />
      </Container>
    </Container>
  );
}

export default Testimonial;
